// This is a wrapper around GlobalPeriodPicker to be used in a facet form
// Weirdly structured because of how the facet menu is structured

import * as React from "react"
import * as ReactDOM from "react-dom"
import * as moment from 'moment';

import {omit} from 'lodash';

import { default as GlobalPeriodPicker } from '../utils/period_picker/GlobalPeriodPicker'
import { StartEnd, DisabledProps, PrefixProps } from '../utils/period_picker/PeriodPicker'
import { FocusedInputShape } from 'react-dates';

type Props = DisabledProps & PrefixProps & StartEnd & {
  onChange: (range: StartEnd) => void
}

type State = StartEnd & {
  focusedInput: FocusedInputShape

}
export default class DateRange extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
      startDate: this.props.startDate,
      endDate:   this.props.endDate,
      focusedInput: null,
    }
  }

  onDatesChange(range: StartEnd) {
    this.setState({ ...range  }, () => this.props.onChange(range))
  }

  getValue() {
    return this.state
  }

  render() {
    return (
      <GlobalPeriodPicker
        prefix={this.props.prefix}
        onDatesChange={(range: StartEnd) => this.onDatesChange(range)}
        startDate={this.props.startDate ? moment(this.props.startDate, "DD-MM-YYYY") : null}
        endDate={this.props.endDate ? moment(this.props.endDate,   "DD-MM-YYYY") : null}
        disabled={this.props.disabled}
        onFocusChange={(fi) => this.setState({focusedInput: fi})}
        focusedInput={this.state.focusedInput}
      />
    )
  }
}